/* eslint-disable */
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { GetLessonDataForLessonId, ILesson } from "../services/lessonPdfService";
import { LessonId } from "../enums/lessonId";
import { useMediaQuery } from "react-responsive";
import ViewSDKClient from "../services/viewSDKClient";

let _viewSDKClient: ViewSDKClient;

const LessonPage = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [size, setSize] = useState<number>(1000);
    const [selectedPdf, setSelectedLesson] = useState<ILesson | undefined>();
    const [pdfs, setLessons] = useState<Array<ILesson>>([]);

    let { id } = useParams();
    const ultraWide = useMediaQuery({ minWidth: 1500 });
    const isDesktop = useMediaQuery({ minWidth: 1224 });
    const isLaptop = useMediaQuery({ minWidth: 992 });
    const isMobile = useMediaQuery({ maxWidth: 767 });

    useEffect(() => {
        debugger
        window.scrollTo(0, 0);
        setLoading(true);
        const lessonData = GetLessonDataForLessonId(id as LessonId);
        const firstData = lessonData[0];
        setSelectedLesson(lessonData[0]);
        setLessons(lessonData);

        if (isLaptop && !isDesktop)
            setSize(1000);
        else if (isMobile && !isLaptop && !isDesktop)
            setSize(350);
        if (firstData.canvaEmbedComponent) {
            setLoading(false);
            return;
        }

        _viewSDKClient = new ViewSDKClient();
        _viewSDKClient.ready().then(() => {
            /* Invoke file preview */
            setLoading(false);
            _viewSDKClient.previewFile("pdf-container", firstData.file, firstData.title, {
                /* Pass the embed mode option here */
                embedMode: "SIZED_CONTAINER"
            });
        });
    }, []);

    const onSelectedPdfChange = (lesson: ILesson) => {
        if (selectedPdf == lesson)
            return;
        setSelectedLesson(lesson);
        if (lesson.file) {
            _viewSDKClient.previewFile("pdf-container", lesson.file, lesson.title, {
                /* Pass the embed mode option here */
                embedMode: "SIZED_CONTAINER"
            });
        }
    }

    const ultraWideToDesktop = (matches: boolean) => {
        if (matches)
            setSize(1200);
        else
            setSize(1000);
    }
    const desktopToLaptop = (matches: boolean) => {
        if (matches)
            setSize(1000);
        else
            setSize(750);
    }
    const laptopToMobile = (matches: boolean) => {
        if (matches)
            setSize(350);
        else
            setSize(750);
    }
    useMediaQuery(
        { minWidth: 1500 },
        undefined,
        ultraWideToDesktop
    )
    useMediaQuery(
        { minWidth: 1224 },
        undefined,
        desktopToLaptop
    )
    useMediaQuery(
        { maxWidth: 767 },
        undefined,
        laptopToMobile,
    )

    return (
        <>
            {loading && <div className="lds-dual-ring"></div>}
            {pdfs?.length > 0 && <h1 className="pdf-title">{pdfs[0].title}</h1>}
            <div className="pdf-parent-container">
                {pdfs.length > 1 && <div className="pdf-selector">
                    {pdfs.map(x => <span key={x.title} onClick={() => onSelectedPdfChange(x)} className="pdf-selector-text title-font text-color" style={{ cursor: 'pointer' }}>{x == selectedPdf ? <u className="text-color">{x.title}</u> : x.title}</span>)}
                </div>}
                {selectedPdf && selectedPdf.canvaEmbedComponent && <div style={{ marginTop: 10, width: size, height: size }}>{(selectedPdf as any).canvaEmbedComponent()}</div>}
                {selectedPdf && selectedPdf.file && <div id="pdf-container" className="pdf-container" style={{ marginTop: 10, width: size, height: size }}>
                </div>}
            </div>
        </>
    );
}

export default LessonPage;